var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 0.750244H12.5C6.0375 0.750244 0.80875 6.03774 0.80875 12.5002L0.75 118.25L24.25 94.7503H106.5C112.963 94.7503 118.25 89.4628 118.25 83.0003V12.5002C118.25 6.03774 112.963 0.750244 106.5 0.750244ZM65.375 71.2503H53.625V59.5003H65.375V71.2503ZM65.375 47.7503H53.625V24.2502H65.375V47.7503Z",
    fill: "#7A7A7A",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.ed0e6c33c8aefbbd85f86b42ecf8381a.svg";
export { ForwardRef as ReactComponent };